import * as actions from "./types";

export const roleList = () => ({
  type: actions.ROLE_LIST_ACTION,
});

export const roleListSuccess = () => ({
  type: actions.ROLE_LIST_ACTION_SUCCESS,
});
